import png1 from "./1.jpg";
import png2 from "./2.jpg";
import png3 from "./3.jpg";
import png4 from "./4.jpg";
export const xyyh = [
  {
    name: "查找流水",
    msgList: [
      { msg: "登录兴业银行APP->首页顶部搜索【导出明细】" },
      { imgs: [png1, png2] },
    ],
  },
  {
    name: "发送账单",
    msgList: [
      {
        msg: "收支类别【全部】，时间选择【近一年】，请不要打开【加密文件】->确认导出",
      },
      { imgs: [png3, png4] },
    ],
  },
  {
    name: "注意事项",
    msgList: [{ msg: "【导出时间段】选择近一年，打开【展示完整卡号】【展示对方信息】【展示账户余额】【展示交易用途】【允许第三方核验】，请不要打开【文件加密】；返回引导页面，在底部点击【上传账单】即可" }],
  },
];
